import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/css/global.css'
import './assets/fonts/iconfont.css'
import axios from 'axios'
import TreeTable from 'vue-table-with-tree-grid'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


//axios.defaults.baseURL = 'https://www.liulongbin.top:8888/api/private/v1/'
//axios.defaults.baseURL = 'http://localhost:8088/'

// 请求头拦截
axios.interceptors.request.use(config => {
    NProgress.start() 
    config.headers.Authorization = window.localStorage.getItem('token')
    return config
})

axios.interceptors.response.use(config => {
    NProgress.done()
    
    if(config.headers.msg != undefined && config.headers.msg == "token_no")
    {
      //跳转login路由，并把目标路由的url路径保存在login的query中
      router.push({
        path:"/login",
        query: {redirect: router.currentRoute.fullPath}
      })
    }
    else if(config.headers.msg != undefined && config.headers.msg == "user_info_alter")
    {
      //跳转login路由，并把目标路由的url路径保存在login的query中
      router.push({
        path:"/login",
        query: {userInfoAlter: 1, redirect: router.currentRoute.fullPath}
      })
    }
    
    return config
})

Vue.prototype.$http = axios

//创建时间函数
/**
 * 获取当前时间
 * 格式YYYY-MM-DD
 */
Vue.prototype.getNowFormatDate = function() {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
};

/**
 * 获取当前时间
 * 格式yyyy-MM-dd HH:mm:ss
 */
Vue.prototype.getNowFormatDateTime = function() { 
  var d = new Date();
  var year = d.getFullYear();
  var month = d.getMonth() < 9 ? "0" + (d.getMonth() + 1) : "" + (d.getMonth() + 1); var day = d.getDate() < 10 ? "0" + d.getDate() : "" + d.getDate();
  var hour = d.getHours() < 10 ? "0" + d.getHours() : "" + d.getHours(); var minutes = d.getMinutes() < 10 ? "0" + d.getMinutes() : "" + d.getMinutes();
  var seconds = d.getSeconds() < 10 ? "0" + d.getSeconds() : "" + d.getSeconds();
  return ( year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds ); }

/**
 * 获取当前时间
 * 格式YYYYMMDD 20201221
 */
Vue.prototype.getNowDateInt = function() {
  var date = new Date();  //当前标准时间格式
  var year = date.getFullYear(); //取得四位数的年份
  var month = date.getMonth() + 1; //返回0~11之间的数字，0代表一月，11代表12月
  var day = date.getDate(); //返回天数，0~31，getDay()返回的是星期几（0~6
  var num = year +""+ month +""+ day;
  return parseInt(num);
};

/**
 * 发货时间是否到期
 */
Vue.prototype.deliveryDateExpire = function(orderInfo) {
  let nowDate = new Date();  //当前标准时间格式
  let deliveryDate = new Date(orderInfo.deliveryDate)
  if(orderInfo.orderStatus !== "运输外包" && orderInfo.orderStatus !== "订单完成" && nowDate.getTime() >= deliveryDate.getTime())
  {
    return true;
  }
  return false;
};

/**
 * 判断是否到下次跟进时间
 */
Vue.prototype.sdownDisposeTimeExpire = function(sdownDisposeTimeStr) {
  let nowDate = new Date();  //当前标准时间格式
  let sdownDisposeTime = new Date(sdownDisposeTimeStr)
  if(nowDate.getTime() >= sdownDisposeTime.getTime())
  {
    return true;
  }
  return false;
};

//判断字符是否为空的方法
Vue.prototype.isEmpty = function(obj){
    if(typeof obj == "undefined" || obj == null || obj == ""){
        return true;
    }else{
        return false;
    }
}

//判断是否是正确金额
Vue.prototype.doubleIntCheck = function(value)
{
  var isNum=/^([1-9][\d]{0,7}|0)(\.[\d]{1,3})?$/;
  if(value !== undefined && value !== null && value !== "" && !isNum.test(value)) {
    return false;
  }
  else
  {
    return true;
  }
},

//判断是否是正确金额
Vue.prototype.squareMeterCheck = function(value)
{
  var isNum=/^([1-9][\d]{0,7}|0)(\.[\d]{1,3})?$/;
  if(value !== undefined && value !== null && value !== "" && !isNum.test(value)) {
    return false;
  }
  else
  {
    return true;
  }
},

// 下载文件处理方法
Vue.prototype.readFileDownload = function(data, msg) {
  var res = data
  if (res.type === 'application/json' || res.type === 'application/json;charset=UTF-8') {     // 失败的时候，注意ie兼容问题
    let fileReader = new FileReader()
    fileReader.onload = function(event) {
      let jsonData = JSON.parse(this.result) // this.result是根据event，读取文件后打印的
      console.log(jsonData, '...............')
      if (jsonData.data === null && jsonData.code === 1) {
        this.$message({
          message: jsonData.msg || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
    fileReader.readAsText(res)
  }
  if (res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || res.type === 'application/octet-stream' || res.type === 'application/vnd.ms-excel' || res.type === 'application/vnd.ms-excel;charset=UTF-8') {
    console.log('success...')         // 成功，注意ie兼容问题

    const blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, msg)
    } else {
      console.log(blob)
      const url = window.URL.createObjectURL(blob)
      console.log(url)
      const aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = url
      aLink.setAttribute('download', msg)
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
      window.URL.revokeObjectURL(url)
    }
  }
},


Vue.component('tree-table', TreeTable)
Vue.use(VueQuillEditor)

Vue.filter('dateFormat', (originVal) => {
    const dt = new Date(originVal)
    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + 1 + '').padStart(2, '0')
    const hh = (dt.getHours() + 1 + '').padStart(2, '0')
    const mm = (dt.getMinutes() + 1 + '').padStart(2, '0')
    const ss = (dt.getSeconds() + 1 + '').padStart(2, '0')
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')